const imageNameCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

export function compareImageNames(
  a: string | undefined | null,
  b: string | undefined | null,
): number | undefined {
  if (!a || !b) return undefined;
  const keyCompare = imageNameCollator.compare(imageBasename(a), imageBasename(b));
  return keyCompare || imageNameCollator.compare(a, b);
}

export function dataLines(text: string): string[] {
  return text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter((line) => line.length > 0 && !line.startsWith('#'));
}

export function imageBasename(name: string): string {
  const normalized = name.replace(/\\/g, '/');
  return normalized.slice(normalized.lastIndexOf('/') + 1);
}

export function readInteger(value: unknown): number | undefined {
  const number = readNumber(value);
  return number === undefined ? undefined : Math.trunc(number);
}

export function readNumber(value: unknown): number | undefined {
  const number =
    typeof value === 'number' ? value : typeof value === 'string' ? Number(value) : NaN;
  return Number.isFinite(number) ? number : undefined;
}

export function readString(value: unknown): string | null {
  return typeof value === 'string' && value.trim() ? value : null;
}
